"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _reactRouterDom = require("react-router-dom");

var _jsxRuntime = require("react/jsx-runtime");

var RedirectAuthenticated = function RedirectAuthenticated(_ref) {
  var redirect = _ref.redirect,
      children = _ref.children;

  // Better do not use suspence here because of truck jobs not using it properly
  var _useAmplifyUser = (0, _Pc.useAmplifyUser)(),
      isAuthenticated = _useAmplifyUser.isAuthenticated;

  if (isAuthenticated) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
      to: redirect
    });
  }

  return children;
};

var _default = RedirectAuthenticated;
exports.default = _default;